import {create} from 'zustand';

interface ContractGeneralInfoModalState {
  open: boolean;

  generalInfoModalOpen: () => void;
  generalInfoModalClose: () => void;
}

export const useContractGeneralInfoModalStore = create<ContractGeneralInfoModalState>((set) => ({
  open: false,

  generalInfoModalOpen: () => set({open: true}),
  generalInfoModalClose: () => set({open: false}),
}));

export const {generalInfoModalOpen, generalInfoModalClose} = useContractGeneralInfoModalStore.getState();
